import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-08e25fde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainContainer flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center flex-1"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center flex-1"
}
const _hoisted_4 = { class: "flex-1 flex overflow-hidden ml-4 lg:ml-6 mb-5" }
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-t border-gray-600" }, null, -1))
const _hoisted_8 = { class: "flex flex-row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-1 text-md text-center border-b border-transparent border-t border-l border-l-gray-600" }, [
  /*#__PURE__*/_createTextVNode("  "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("  ")
], -1))
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-b border-transparent border-l border-l-gray-600" }, null, -1))

import { Form, FormContext, GenericObject, SubmissionHandler, useForm } from "vee-validate";
import { computed, onMounted, Ref, ref, watch } from "vue";
import { onBeforeRouteLeave } from "vue-router";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import { useHierarchyTags } from "shared/composables/hierarchyTags";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useSaveBeforeLeaveConfirmationModal } from "shared/composables/toast";
import { useTrackEvent } from "shared/composables/tracking";
import logger from "shared/services/logger";
import Sidebar from "@/components/layout/Sidebar.vue";
import { useSaveUnitValues, useUnitValueAggregates, useUnitValues } from "@/composables/unitValues";
import UnitValueRepository from "@/repositories/UnitValueRepository";
import {
  UnitValue,
  UnitValueRowTag,
  UnitValueType,
  UnitValueColumnModalForm,
} from "@/types/UnitValue";
import ColumnModal from "@/views/unit_values/components/ColumnModal.vue";
import SummaryCells from "@/views/unit_values/components/SummaryCells.vue";
import TypeHeader from "@/views/unit_values/components/TypeHeader.vue";
import UnitValuesEditorHeader from "@/views/unit_values/components/UnitValuesEditorHeader.vue";
import UnitValuesEditorTags from "@/views/unit_values/components/UnitValuesEditorTags.vue";
import ValueCells from "@/views/unit_values/components/ValueCells.vue";
import { useExcelExport } from "@/views/unit_values/services/excelExport";
import {
  addUnitValuesType,
  calculateUnitValueAggregatesByType,
  deleteUnitValuesByType,
  getApproved,
  mergeRows,
  modifyUnitValuesType,
  setApproved,
  setTypeAdjustmentFields,
  splitRows,
} from "@/views/unit_values/services/unitValues";
import valueCellFocusService from "@/views/unit_values/services/valueCellFocusService";
import { useScroll, useUnitValuesForm } from "./composables";
import "./styles.css";

const firstHeaderRowHeight = 35;
const secondHeaderRowHeight = 57;
const rowHeight = 33;
const columnWidth = 300;
const rightBorderWidth = 20;
const defaultTagColumnWidth = 350;


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitValuesEditor',
  setup(__props) {

const isColumnModalOpen = ref(false);
const columnModalUnitValue = ref<UnitValue | null>(null);
const selectedTagIds = ref<string[]>([]);
const isAdminMode = ref(false);
const focusedUnitValue = ref<UnitValue | null>(null);
const formRef = ref<FormContext | null>(null);
const unitValuesTagsRef = ref<{ tagHeaderRef: Ref<HTMLDivElement | null> } | null>(null);
const tagColumnWidth = ref(defaultTagColumnWidth);

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();

const { unitValues, isLoading: areUnitValuesLoading } = useUnitValues();
const { hierarchyTags, isLoading: areHierarchyTagsLoading } = useHierarchyTags();
const { unitValueAggregates, areUnitValueAggregatesLoading } = useUnitValueAggregates({
  failSilently: true,
});
const { saveUnitValues } = useSaveUnitValues();
const { schema, initialValues, getUnitValuesListFromForm, setUnitValuesInForm } = useUnitValuesForm(
  unitValues,
  hierarchyTags,
);
const {
  mainContentRef,
  tagHeaderRef,
  valuesHeaderRef,
  summaryFooterRef,
  rightBorderRef,
  calculateScrollbarSize,
  handleMainScroll,
  handleVerticalScroll,
  handleHorizontalScroll,
  enablePan,
  disablePan,
  handleMouseMove,
  scrollBarWidth,
  scrollBarHeight,
} = useScroll();
const { setValues: _useFormSetValues } = useForm();
const exportToExcel = useExcelExport();
const showSaveBeforeLeaveConfirmationModal = useSaveBeforeLeaveConfirmationModal();
const trackEvent = useTrackEvent();

const addTypeClicked = ref(false);

const hasData = computed(
  () =>
    unitValues.value &&
    unitValues.value.length > 0 &&
    hierarchyTags.value &&
    hierarchyTags.value.length > 0,
);

const isLoading = computed(
  () =>
    areUnitValuesLoading.value ||
    areHierarchyTagsLoading.value ||
    areUnitValueAggregatesLoading.value,
);

const hasBuilding = computed(
  () =>
    unitValues.value &&
    unitValues.value.some((unitValue) => unitValue.tags.some((tag) => tag.building_id)),
);

const unitValueAggregatesByType = computed(() => {
  if (!unitValueAggregates.value) {
    return {} as Record<UnitValueType, undefined>;
  }
  return calculateUnitValueAggregatesByType(unitValueAggregates.value);
});

const getSelectedRowTagsFromForm = (values: GenericObject) =>
  (values.tags as UnitValueRowTag[])
    .filter((rowTag) => selectedTagIds.value.includes(rowTag.id))
    .map((rowTag) => rowTag.tags);

const handleSubmit: SubmissionHandler = async (genericObject, { resetForm }) => {
  try {
    trackEvent("unit-values_save");
    await saveUnitValues(getUnitValuesListFromForm(genericObject));
    resetForm(
      {
        values: initialValues.value,
      },
      { force: true },
    );
    selectedTagIds.value = [];
  } catch {
    // have to catch the error here, otherwise it's propagated as an unhandled error
    // it's already logged by vue-query
    return undefined;
  }
};

const handleMergeRowsClick = (values: GenericObject, setValues: typeof _useFormSetValues) => {
  trackEvent("unit-values_merge_apply");
  const tagsToMerge = getSelectedRowTagsFromForm(values);
  const newUnitValues = mergeRows(getUnitValuesListFromForm(values), tagsToMerge);
  setUnitValuesInForm(values, setValues, newUnitValues);
  selectedTagIds.value = [];
  setTimeout(() => {
    calculateScrollbarSize();
  }, 20);
};

const handleSplitRowsClick = (values: GenericObject, setValues: typeof _useFormSetValues) => {
  trackEvent("unit-values_split_apply");
  const tagsToSplit = getSelectedRowTagsFromForm(values);
  const newUnitValues = splitRows(getUnitValuesListFromForm(values), tagsToSplit);
  setUnitValuesInForm(values, setValues, newUnitValues);
  selectedTagIds.value = [];
  setTimeout(() => {
    calculateScrollbarSize();
  }, 20);
};

const getModifiedOrAddedUnitValues = (
  unitValues: UnitValue[],
  unitValueColumnModalForm: UnitValueColumnModalForm,
) => {
  if (
    columnModalUnitValue.value &&
    columnModalUnitValue.value.type === unitValueColumnModalForm.type
  ) {
    return unitValues;
  }
  return columnModalUnitValue.value
    ? modifyUnitValuesType(
        unitValues,
        columnModalUnitValue.value.type,
        unitValueColumnModalForm.type,
      )
    : addUnitValuesType(unitValues, unitValueColumnModalForm.type);
};

const getRecalculatedUnitValuesFromBackend = async (
  unitValues: UnitValue[],
  unitValueColumnModalForm: UnitValueColumnModalForm,
) => {
  try {
    if (
      columnModalUnitValue.value &&
      columnModalUnitValue.value.type === unitValueColumnModalForm.type
    ) {
      return unitValues;
    }
    return await UnitValueRepository.calculateUnitValueFields(
      currentCustomerName,
      currentSiteId,
      unitValues,
    );
  } catch (error) {
    logger.error(error);
    return unitValues;
  }
};

const handleColumModalConfirmed = async (
  unitValueColumnModalForm: UnitValueColumnModalForm,
  values: GenericObject,
  setValues: typeof _useFormSetValues,
) => {
  if (addTypeClicked.value) {
    trackEvent("unit-values_value_create");
    addTypeClicked.value = false;
  } else {
    trackEvent("unit-values_value-edit_save");
  }
  const currentUnitValues = getUnitValuesListFromForm(values);
  const newUnitValues = getModifiedOrAddedUnitValues(currentUnitValues, unitValueColumnModalForm);
  const newUnitValuesWithTypeAdjustmentFields = setTypeAdjustmentFields(
    newUnitValues,
    unitValueColumnModalForm.type,
    {
      type_duration_factor: unitValueColumnModalForm.type_duration_factor,
      type_workforce_delta: unitValueColumnModalForm.type_workforce_delta,
      type_value_delta: unitValueColumnModalForm.type_value_delta,
    },
  );
  const recalculatedUnitValuesFromBackend = await getRecalculatedUnitValuesFromBackend(
    newUnitValuesWithTypeAdjustmentFields,
    unitValueColumnModalForm,
  );
  setUnitValuesInForm(values, setValues, recalculatedUnitValuesFromBackend);
  columnModalUnitValue.value = null;
  isColumnModalOpen.value = false;
  setTimeout(() => {
    calculateScrollbarSize();
  }, 100);
};

const handleColumnModalDeleted = (
  type: UnitValueType,
  values: GenericObject,
  setValues: typeof _useFormSetValues,
) => {
  const newUnitValues = deleteUnitValuesByType(getUnitValuesListFromForm(values), type);
  setUnitValuesInForm(values, setValues, newUnitValues);
  columnModalUnitValue.value = null;
  isColumnModalOpen.value = false;
  trackEvent("unit-values_value_delete");
  setTimeout(() => {
    calculateScrollbarSize();
  }, 100);
};

const getErrorField = (
  type: UnitValueType,
  tag: UnitValueRowTag,
  errors: Record<string, string | undefined>,
) => {
  const key = `uw_${type}_${tag.id}`;
  const error = errors[key];
  if (error) {
    const matches = error.match(/^.*?\.(.*?) .*$/);
    if (matches && matches[1]) {
      return matches[1].replace(key, "");
    }
  }
  return null;
};

const toggleApproved = (values: GenericObject, setValues: typeof _useFormSetValues) => {
  const unitValues = getUnitValuesListFromForm(values);
  const isApproved = getApproved(unitValues);
  const newUnitValues = setApproved(unitValues, !isApproved);
  setUnitValuesInForm(values, setValues, newUnitValues);
};

watch(
  () => unitValuesTagsRef.value,
  () => {
    tagHeaderRef.value = unitValuesTagsRef.value?.tagHeaderRef ?? null;
  },
);

onBeforeRouteLeave((to, from, next) => {
  if (!formRef.value || !formRef.value.meta.dirty) {
    return next();
  }
  showSaveBeforeLeaveConfirmationModal().then((confirmed) => {
    if (confirmed) {
      next();
    }
  });
});

onMounted(() => {
  trackEvent("unit-values_view");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Sidebar, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(LoadingSpinner)
            ]))
          : _createCommentVNode("", true),
        (!isLoading.value && !hasData.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("unit_values.no_unit_values")), 1))
          : _createCommentVNode("", true),
        (!isLoading.value && hasData.value)
          ? (_openBlock(), _createBlock(_unref(Form), {
              key: 2,
              ref_key: "formRef",
              ref: formRef,
              onSubmit: handleSubmit,
              initialValues: _unref(initialValues),
              validationSchema: _unref(schema) as (typeof Form)['validationSchema'],
              class: "flex-1 flex flex-col overflow-hidden relative"
            }, {
              default: _withCtx(({ isSubmitting, values, setFieldValue, meta, errors, setValues }) => [
                _createVNode(UnitValuesEditorHeader, {
                  approved: _unref(getApproved)(_unref(getUnitValuesListFromForm)(values)),
                  isSubmitting: isSubmitting,
                  isSubmitDisabled: isSubmitting || !meta.dirty || !meta.valid,
                  isAdminMode: isAdminMode.value,
                  onAddTypeClicked: _cache[0] || (_cache[0] = ($event: any) => {
            addTypeClicked.value = true;
            columnModalUnitValue.value = null;
            isColumnModalOpen.value = true;
          }),
                  onExcelExportClicked: ($event: any) => {
            _unref(trackEvent)('unit-values_export-excel_click');
            _unref(exportToExcel)(_unref(getUnitValuesListFromForm)(values), _unref(hierarchyTags));
          },
                  onToggleApproveClicked: ($event: any) => (toggleApproved(values, setValues)),
                  onToggleAdminMode: _cache[1] || (_cache[1] = ($event: any) => (isAdminMode.value = !isAdminMode.value))
                }, null, 8, ["approved", "isSubmitting", "isSubmitDisabled", "isAdminMode", "onExcelExportClicked", "onToggleApproveClicked"]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(UnitValuesEditorTags, {
                    ref_key: "unitValuesTagsRef",
                    ref: unitValuesTagsRef,
                    tags: values.tags,
                    selectedTagIds: selectedTagIds.value,
                    hasBuilding: !!hasBuilding.value,
                    focusedUnitValue: focusedUnitValue.value,
                    tagColumnWidth: tagColumnWidth.value,
                    firstHeaderRowHeight: firstHeaderRowHeight,
                    secondHeaderRowHeight: secondHeaderRowHeight,
                    rowHeight: rowHeight,
                    scrollBarHeight: _unref(scrollBarHeight),
                    onScrolled: _unref(handleVerticalScroll),
                    onSelectedTagIdsChanged: _cache[2] || (_cache[2] = ($event: any) => (selectedTagIds.value = $event)),
                    onMerged: ($event: any) => (handleMergeRowsClick(values, setValues)),
                    onSplit: ($event: any) => (handleSplitRowsClick(values, setValues)),
                    onTagColumnWidthChanged: _cache[3] || (_cache[3] = ($event: any) => (
              tagColumnWidth.value = $event === null ? defaultTagColumnWidth : $event
            ))
                  }, null, 8, ["tags", "selectedTagIds", "hasBuilding", "focusedUnitValue", "tagColumnWidth", "scrollBarHeight", "onScrolled", "onMerged", "onSplit"]),
                  _createElementVNode("div", {
                    class: "flex flex-col relative",
                    style: _normalizeStyle(`max-width: calc(100% - ${
              tagColumnWidth.value + _unref(scrollBarWidth) + rightBorderWidth
            }px)`)
                  }, [
                    _createElementVNode("div", {
                      class: "flex shrink-0 overflow-auto unitValueHideScrollBar z-30",
                      ref_key: "valuesHeaderRef",
                      ref: valuesHeaderRef,
                      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(handleHorizontalScroll) && _unref(handleHorizontalScroll)(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.types, (type, index) => {
                          return (_openBlock(), _createBlock(TypeHeader, {
                            key: type,
                            firstHeaderRowHeight: firstHeaderRowHeight,
                            secondHeaderRowHeight: secondHeaderRowHeight,
                            columnWidth: columnWidth,
                            type: type,
                            isLastType: index !== values.types.length - 1,
                            unitValue: values[`uw_${type}_${values.tags[0].id}`],
                            onEditClicked: ($event: any) => {
                    columnModalUnitValue.value = values[`uw_${type}_${values.tags[0].id}`];
                    isColumnModalOpen.value = true;
                  }
                          }, null, 8, ["type", "isLastType", "unitValue", "onEditClicked"]))
                        }), 128))
                      ])
                    ], 544),
                    _createElementVNode("div", {
                      class: "overflow-auto overscroll-none flex select-none z-40 unitValueHideScrollBar",
                      ref_key: "mainContentRef",
                      ref: mainContentRef,
                      onScroll: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(handleMainScroll) && _unref(handleMainScroll)(...args))),
                      onMousemove: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_unref(handleMouseMove) && _unref(handleMouseMove)(...args))),
                      onMousedown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(enablePan) && _unref(enablePan)(...args))),
                      onMouseup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_unref(disablePan) && _unref(disablePan)(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((values.types as UnitValueType[]), (type, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: _normalizeStyle(`width: ${columnWidth}px`),
                            key: type
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.tags, (tag) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "unitValueValueColumns bg-white",
                                key: tag.id,
                                style: _normalizeStyle(`height: ${rowHeight}px`)
                              }, [
                                _createVNode(ValueCells, {
                                  unitValue: values[`uw_${type}_${tag.id}`],
                                  tag: tag,
                                  isAdminMode: isAdminMode.value,
                                  rowHeight: rowHeight,
                                  errorField: getErrorField(type, tag, errors),
                                  showLastRightBorder: index !== values.types.length - 1,
                                  unitValueAggregate: unitValueAggregatesByType.value[type],
                                  onChanged: ($event: any) => (setFieldValue(`uw_${type}_${tag.id}`, $event)),
                                  onFocused: _cache[5] || (_cache[5] = ($event: any) => (focusedUnitValue.value = $event)),
                                  onBlurred: _cache[6] || (_cache[6] = ($event: any) => (focusedUnitValue.value = null)),
                                  onNavigated: ($event: any) => (
                        _unref(valueCellFocusService).focusCell({
                          currentField: $event.field,
                          direction: $event.direction,
                          type,
                          types: values.types,
                          tag,
                          tags: values.tags,
                          fields: $event.fields,
                        })
                      )
                                }, null, 8, ["unitValue", "tag", "isAdminMode", "errorField", "showLastRightBorder", "unitValueAggregate", "onChanged", "onNavigated"])
                              ], 4))
                            }), 128))
                          ], 4))
                        }), 128))
                      ])
                    ], 544),
                    _hoisted_7,
                    _createElementVNode("div", {
                      class: "flex shrink-0 overflow-x-auto overflow-y-hidden z-30",
                      ref_key: "summaryFooterRef",
                      ref: summaryFooterRef,
                      onScroll: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_unref(handleHorizontalScroll) && _unref(handleHorizontalScroll)(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(values.types, (type, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            style: _normalizeStyle(`width: ${columnWidth}px`),
                            key: type
                          }, [
                            _createElementVNode("div", {
                              class: "unitValueValueColumns border-b border-gray-600 bg-white",
                              style: _normalizeStyle(`height: ${rowHeight}px`)
                            }, [
                              _createVNode(SummaryCells, {
                                type: type,
                                unitValues: _unref(getUnitValuesListFromForm)(values),
                                showLastRightBorder: index !== values.types.length - 1
                              }, null, 8, ["type", "unitValues", "showLastRightBorder"])
                            ], 4)
                          ], 4))
                        }), 128))
                      ])
                    ], 544)
                  ], 4),
                  _createElementVNode("div", {
                    class: "flex flex-col overflow-x-hidden overflow-y-auto shrink-0",
                    ref_key: "rightBorderRef",
                    ref: rightBorderRef,
                    style: _normalizeStyle(`z-index: 50; max-height: calc(100% - ${_unref(scrollBarHeight)}px); width: ${
              _unref(scrollBarWidth) ? _unref(scrollBarWidth) + 1 : rightBorderWidth
            }px;${_unref(scrollBarWidth) === 0 ? 'direction: rtl' : ''}`),
                    onScroll: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_unref(handleVerticalScroll) && _unref(handleVerticalScroll)(...args)))
                  }, [
                    _createElementVNode("div", {
                      class: "p-1 text-md border-b border-transparent border-l border-l-gray-600",
                      style: _normalizeStyle(`height: ${firstHeaderRowHeight}px`)
                    }, "   ", 4),
                    _hoisted_9,
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...values.tags, { id: 'summary' }], (tag) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-1 text-md text-center border-b border-transparent border-l border-l-gray-600",
                            key: tag.id,
                            style: _normalizeStyle(`height: ${rowHeight}px`)
                          }, "   ", 4))
                        }), 128))
                      ])
                    ]),
                    _hoisted_11
                  ], 36)
                ]),
                (isColumnModalOpen.value)
                  ? (_openBlock(), _createBlock(ColumnModal, {
                      key: 0,
                      existingTypes: values.types,
                      unitValue: columnModalUnitValue.value,
                      canDelete: values.types.length > 1,
                      onClosed: _cache[13] || (_cache[13] = ($event: any) => {
            isColumnModalOpen.value = false;
            columnModalUnitValue.value = null;
          }),
                      onConfirmed: ($event: any) => (handleColumModalConfirmed($event, values, setValues)),
                      onDeleted: ($event: any) => (handleColumnModalDeleted($event, values, setValues))
                    }, null, 8, ["existingTypes", "unitValue", "canDelete", "onConfirmed", "onDeleted"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["initialValues", "validationSchema"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})